import { GlAlert, GlLink, GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { helpPagePath } from '~/helpers/help_page_helper';
import { getTransferLocations, transferProject } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/api/projects_api.js?vue3';
import { s__, sprintf } from '~/locale';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import TransferModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/groups_projects/components/transfer_modal.vue?vue3';
export default {
    name: 'TransferProjectModal',
    components: {
        TransferModal,
        GlAlert,
        GlLink,
        GlSprintf
    },
    provide () {
        return {
            resourceId: String(this.project.id),
            resourcePath: this.project.path,
            resourceFullPath: this.project.fullPath
        };
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        project: {
            type: Object,
            required: true
        }
    },
    emits: [
        'change',
        'success'
    ],
    computed: {
        title () {
            return sprintf(s__('NamespaceTransfer|Transfer - %{name}'), {
                name: this.project.name
            });
        }
    },
    methods: {
        handleError (error) {
            createAlert({
                message: error || s__('NamespaceTransfer|An error occurred while transferring the project. Please refresh the page to try again.'),
                captureError: true,
                error
            });
        }
    },
    getTransferLocations,
    transferProject,
    transferDocsPath: helpPagePath('user/project/working_with_projects', {
        anchor: 'transfer-a-project'
    })
};
